import React from 'react';
import EditElement from '../../components/EditElement';
import { CUSTOM_PAGES_INFO } from '../../config';
import ButtonsBar from '../../components/ButtonsBar';
import WithCustomConfig from '../../hocs/WithCustomConfig';
import { useTranslation } from 'react-i18next';

const CustomElement = (props) => {
	const { configInfo = {}, submitHandler, id, basicInfo } = props.pageConfig;
	const [t] = useTranslation('app');

	return (
		<div className={props.className || 'CustomElement'}>
			<ButtonsBar id={id} config={configInfo} formData={basicInfo} />
			{Array.isArray(configInfo.fields) ? (
				<EditElement
					id={id}
					basicInfo={basicInfo}
					config={configInfo}
					noEditable={props.noEditable || basicInfo.block_form}
					onSubmit={submitHandler}
					dadesTecniques={basicInfo['supplementary_data']}
				/>
			) : (
				<p>{t('errors.no_form_info')}...</p>
			)}
		</div>
	);
};

export default WithCustomConfig(CustomElement, CUSTOM_PAGES_INFO.element);
